export const productFullName = product => {
	const provider =
		product && product.provider && product.provider !== '---'
			? ' - (' + product.provider + ')'
			: ''
	return product.name + provider
}



// WEBPACK FOOTER //
// ./src/utils/productFullName.js